import { Injectable } from '@angular/core';
import { RoleMenuModel } from '../../../pages/role/shared/model';
import { BehaviorSubject, Observable } from 'rxjs';

@Injectable({
	providedIn: 'root'
})
export class AuthService {
	private menuTreesSubject: BehaviorSubject<RoleMenuModel[]> = new BehaviorSubject<RoleMenuModel[]>([]);
	menuTrees$: Observable<RoleMenuModel[]> = this.menuTreesSubject.asObservable();

	private authorizedMenuIdsSubject: BehaviorSubject<string[]> = new BehaviorSubject<string[]>([]);
	authorizedMenuIds$: Observable<string[]> = this.authorizedMenuIdsSubject.asObservable();

	private roleAccessSubject: BehaviorSubject<string[]> = new BehaviorSubject<string[]>([]);
	roleAccess$: Observable<string[]> = this.roleAccessSubject.asObservable();

	set menuTrees(menus: RoleMenuModel[]) {
		this.menuTreesSubject.next(menus);
	}

	get menuTrees() {
		return this.menuTreesSubject.value;
		// return this.#menuTrees$;
	}

	set authorizedMenuIds(value: string[]) {
		this.authorizedMenuIdsSubject.next(value);
	}

	get authorizedMenuIds() {
		return this.authorizedMenuIdsSubject.value;
	}

	set roleAccesses(value: string[]) {
		this.roleAccessSubject.next(value);
	}

	get roleAccesses() {
		return this.roleAccessSubject.value;
	}
}
